import React, { Fragment } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import PropTypes from "prop-types";

import styles from "../../App.module.css";
import { Link } from "react-router-dom";

const ThankYou = () => (
  <Fragment>
    <Card className={[styles["Card"]]}>
      <Card body className={[styles["CardLvl2"], styles["larger-text"]]}>
        <Card.Body className={styles["flex-wrapper-between"]}>
          <Card.Text>Your application has been submitted. Thank you.</Card.Text>
          <Link to={"/"} replace>
            <Button className={styles["btn-round"]}>Return to Homepage</Button>
          </Link>
        </Card.Body>
      </Card>
    </Card>
  </Fragment>
);

ThankYou.propTypes = {
  name: PropTypes.string,
};

export default ThankYou;
